/*
 * Gabi — „Uzupełnij swoją stylizację" w koszyku wysuwanym
 * (snippets/gabi-koszyk-stylizacja.liquid).
 *
 * Pobiera karty dopiero przy otwarciu koszyka. Najpierw produkty uzupełniające
 * (Search & Discovery), gdy ich brak — automatyczne rekomendacje Shopify.
 * Odpowiedzi trzymamy w pamięci strony: koszyk przerysowuje się przy każdej
 * zmianie ilości i bez tego karuzela migałaby i pobierała się od nowa.
 *
 * Skrypt jest w pierwszym HTML strony (snippets/cart-drawer.liquid, poza
 * #CartDrawer-Body), także przy pustym koszyku. Wstawiony razem z podmianą
 * koszyka przez innerHTML przeglądarka go nie uruchamia — karuzela zostawała
 * schowana po pierwszym dodaniu.
 */
if (!customElements.get('gabi-koszyk-stylizacja')) {
  const responses = new Map();
  const LIST = { item_list_id: 'cart_complete_look', item_list_name: 'Uzupełnij swoją stylizację' };
  let listViewed = false;

  class GabiKoszykStylizacja extends HTMLElement {
    connectedCallback() {
      this.items = this.querySelector('[data-stylizacja-items]');
      this.addEventListener('click', this.onClick);

      // Czekamy na otwarcie koszyka (cart-drawer dostaje wtedy klasę is-visible).
      const drawer = this.closest('cart-drawer');
      if (!drawer || drawer.classList.contains('is-visible')) {
        this.load();
        return;
      }
      this.observer = new MutationObserver(() => {
        if (!drawer.classList.contains('is-visible')) return;
        this.observer.disconnect();
        this.load();
      });
      this.observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.slider?.destroy();
    }

    async load() {
      if (this.dataset.url) {
        for (const intent of ['complementary', 'related']) {
          const html = await this.fetchItems(`${this.dataset.url}&intent=${intent}`);
          if (html) {
            this.items.innerHTML = html;
            break;
          }
        }
      }
      this.show();
    }

    fetchItems(url) {
      // Po przerysowaniu koszyka section_id ma inną postać, a odpowiedź jest ta sama.
      const key = url.replace(/section_id=[^&]*&?/, '');
      if (!responses.has(key)) {
        responses.set(key, fetch(url)
          .then(response => (response.ok ? response.text() : ''))
          .then(text => {
            const items = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('[data-stylizacja-items]');
            return items && items.children.length ? items.innerHTML : '';
          })
          .catch(() => ''));
      }
      return responses.get(key);
    }

    show() {
      if (!this.isConnected || !this.items.children.length) return;
      this.hidden = false;
      if (typeof Swiper !== 'undefined') {
        this.slider = new Swiper(this.querySelector('.swiper'), {
          slidesPerView: 'auto',
          spaceBetween: 12,
          navigation: {
            prevEl: this.querySelector('[data-stylizacja-prev]'),
            nextEl: this.querySelector('[data-stylizacja-next]')
          }
        });
      }
      this.trackView();
    }

    dlItems(elements) {
      return elements.map(el => {
        try {
          const index = [...this.items.children].indexOf(el);
          return DL.buildItem({ ...JSON.parse(el.dataset.dlItem), index, ...LIST });
        } catch {
          return null;
        }
      }).filter(Boolean);
    }

    trackView() {
      if (listViewed || !window.DL?.push) return;
      listViewed = true;
      const items = this.dlItems([...this.querySelectorAll('[data-dl-item]')]);
      if (items.length) {
        DL.push('view_item_list', { component: 'cart_complete_look', ecommerce: { ...LIST, items } });
      }
    }

    onClick = event => {
      const slide = event.target.closest('a')?.closest('[data-dl-item]');
      if (!slide || !window.DL?.push) return;
      const items = this.dlItems([slide]);
      if (items.length) {
        DL.push('select_item', { component: 'cart_complete_look', ecommerce: { ...LIST, items } });
      }
    };
  }

  customElements.define('gabi-koszyk-stylizacja', GabiKoszykStylizacja);
}
